// THIS FILE IS AUTO-GENERATED. DO NOT EDIT. Re-run --exportTsApi to regenerate.
import { AggregatedTargetAttribute } from "./Reports.AggregatedTargetAttribute.gen";

export interface ITotalVolumeByPeriod {
	periodStart: string | undefined;

	count: number;

	aggregatedAttribute: AggregatedTargetAttribute;

	attributeValue: number;

	avgVelocity: number;

	inCount: number;

	outCount: number;

	$type?: string | undefined;
}
export class TotalVolumeByPeriod {
	constructor(data?: ITotalVolumeByPeriod) {
		if (!data) return;
		if (data.$type && data.$type !== this.$type) console.warn('The $type of data being parsed does not match the type of the object being created (' + this.$type + ')');
		Object.assign(this, data);
		if (data.periodStart) { this.periodStart = new Date(data.periodStart); }
	}

	periodStart: Date | undefined = new Date();

	count: number = 0;

	aggregatedAttribute: AggregatedTargetAttribute = 0;

	attributeValue: number = 0;

	avgVelocity: number = 0;

	inCount: number = 0;

	outCount: number = 0;

	static $type: string = "CoreApi.Models.Reports.TotalVolumeByPeriod, ";
	$type?: string | undefined = TotalVolumeByPeriod.$type;
}

